import { render, staticRenderFns } from "./powerDialogContent.vue?vue&type=template&id=2d85c0ad"
import script from "./powerDialogContent.vue?vue&type=script&lang=js"
export * from "./powerDialogContent.vue?vue&type=script&lang=js"
import style0 from "./powerDialogContent.vue?vue&type=style&index=0&id=2d85c0ad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports